import React from "react";
import { LoginForm } from "./components";
import { useLocation, useNavigate } from "react-router-dom";
import { LoginPageCmp, LoginPageProps } from "./types";
import { Routes } from "../../navigation";

const LoginPage: LoginPageCmp = (props: LoginPageProps) => {
  const [redirect, setRedirect] = React.useState(false);

  let location = useLocation();
  let navigate = useNavigate();

  const redirectToHomePage = () => {
    setRedirect(true);
  };

  if (redirect) {
    navigate(location)
  }

  return <LoginForm afterLogin={redirectToHomePage} />;
};

LoginPage.route = Routes.LoginPage;

export default LoginPage;
